<div>
  <div class="row">
    <div class="col px-md-3">
      <h2 class="font-title" [innerHTML]="translatedTitle ?? (title | translate:titleParams)"></h2>
      <h5 class="font-title" [innerHTML]="subtitle | translate:subtitleParams" *ngIf="subtitle"></h5>
      <hr class="divider">
    </div>
  </div>
</div>
